import { AES, enc } from 'crypto-js';
var user = {
  setUser: function(userCode, sessionId, expires, avatar, phone) {
    let timestamp = new Date().getTime();
    let params = {
      userCode: userCode,
      sessionId: sessionId,
      expires: expires * 1000,
      timestamp: timestamp,
      avatar: avatar,
      phone: phone,
    };
    let str = JSON.stringify(params);
    let value = AES.encrypt(str, this.key()).toString();
    localStorage.setItem('userSession', value);
  },
  getUser: function() {
    let value = localStorage.getItem('userSession');
    if (value == null) {
      return null;
    }
    let bytes = AES.decrypt(value, this.key());
    let text = bytes.toString(enc.Utf8);
    let o = JSON.parse(text);
    let now = new Date().getTime();
    if (o.expires > 0) {
      if (now - o.timestamp > o.expires) {
        localStorage.removeItem('userSession');
        return null;
      } else {
        return o;
      }
    } else {
      return o;
    }
  },
  update: function() {
    let u = this.getUser();
    if (u == null) {
      return;
    }
    this.setUser(u.userCode, u.sessionId, u.expires / 1000, u.avatar, u.phone);
  },
  key: function() {
    return 'cbs_yi_tong_key';
  },
  logout: function() {
    localStorage.removeItem('userSession');
  },
};
export default user;
